module.exports = __webpack_public_path__ + "static/img/logo-entreproamd-user.c832262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-entreproamd-user.png
// module id = zCR7
// module chunks = 1